import { render } from "./ReportValueBranchndex.vue?vue&type=template&id=497ad36d&scoped=true"
import script from "./ReportValueBranchndex.vue?vue&type=script&lang=js"
export * from "./ReportValueBranchndex.vue?vue&type=script&lang=js"

import "./ReportValueBranchndex.vue?vue&type=style&index=0&id=497ad36d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497ad36d"]])

export default __exports__